// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RimSrDvZAOoawM {
  display: inline-flex;
  border-radius: 3px;
  font-size: 12px;
  padding: 4px;
  text-decoration: none;
  line-height: 12px;
  margin-bottom: 0;
}
.z38jNy7nvTVKlw {
  display: flex;
  justify-content: center;
  width: 12px;
  height: 12px;
  margin-right: 4px;
  line-height: 12px;
}
.z38jNy7nvTVKlw > span {
  width: 12px;
  height: 12px;
}
.nchef4Wte4nGVu {
  background-color: var(--ds-background-discovery, #f3f0ff);
  color: var(--ds-text-subtle, #44546f);
}
.nchef4Wte4nGVu .z38jNy7nvTVKlw svg {
  color: var(--ds-icon-discovery, #8270db);
}
.nchef4Wte4nGVu:hover {
  background-color: var(--ds-background-discovery-hovered, #dfd8fd);
  color: var(--ds-text-subtle, #44546f);
}
.V2zmvVvZ5AC_wV {
  background-color: var(--ds-background-discovery-bold, #6e5dc6);
  color: var(--ds-text-inverse, #ffffff);
}
.V2zmvVvZ5AC_wV .z38jNy7nvTVKlw svg {
  color: var(--ds-icon-inverse, #ffffff);
}
.V2zmvVvZ5AC_wV:hover {
  background-color: var(--ds-background-discovery-bold-hovered, #583f68);
  color: var(--ds-text-inverse, #ffffff);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upgradePromptPill": `RimSrDvZAOoawM`,
	"upgradePromptPillIcon": `z38jNy7nvTVKlw`,
	"upgradeLightTheme": `nchef4Wte4nGVu`,
	"upgradeDarkTheme": `V2zmvVvZ5AC_wV`
};
export default ___CSS_LOADER_EXPORT___;
